import {
    getUserProfile,
    getAuthLoginUrl,
    getAuthLogoutUrl,
    getProfileUrl,
    getSettingsUrl,
    fetchTBIDInfo,
    fetchLoginMethodsByClientId,
    updateProfile,
    getPolicyViolations,
    remediatePolicyViolation,
    hasEdoAccount,
} from './utils';
import { initSso } from './sso';
import { TBIDVals } from './types';
import { initTracking } from './auth-tracking';
import { getEnv } from './config';
import { getProfileFields } from './common/profile-completion';
declare global {
    interface Window {
        authInit: boolean;
    }
}

const NAME = 'iis-module';

//setupLocalStorageListeners();

// pass on isUserLoggedInto to determine flow for retrieving user's tbid info
let userProfile: Promise<TBIDVals | undefined> = getUserProfile();

type AsyncStringFunction = () => Promise<string | undefined>;
type State = {
    loginUrlResolver: AsyncStringFunction;
};

let state: State = {
    loginUrlResolver: getAuthLoginUrl,
};

/**
 * setLoginUrlResolver
 * @function setLoginUrlResolver
 * @param resolver
 * @returns {void}
 */
export const setLoginUrlResolver = (resolver: AsyncStringFunction): void => {
    state.loginUrlResolver = resolver;
};

const initializeState = (currentState: State, existingState?: State): State => existingState ?? currentState;

// in case state is reset from multiple loads
if (typeof window !== 'undefined') {
    state = (window as any)[NAME] = initializeState(state, (window as any)[NAME]);
}

const refreshUserInfo = async () => {
    userProfile = await fetchTBIDInfo();
    return userProfile;
};

export default {
    getAuthLoginUrl: async () => await state.loginUrlResolver(),
    getAuthLogoutUrl,
    getProfileUrl,
    getSettingsUrl,
    getProfileFields,
    getEnv,
    getUserInfo: async (): Promise<Record<string, any> | undefined> => (await userProfile)?.userInfo,

    // user is authenticated if iis_*t cookie exists OR /user call returns data
    isUserAuthenticated: async (): Promise<boolean> => !!(await userProfile),

    // Expose method to refresh user profile information
    refreshUserInfo,

    // Expose method to get login methods by clientId
    fetchLoginMethodsByClientId,
    // Expose method to update user profile information
    updateProfile,
    // For fetching policy Violations methods
    getPolicyViolations,

    // For remediating policy violations.
    remediatePolicyViolation,

    // Returns true to indicate EDO user status
    hasEdoAccount,
};

// set a variable to ensure this functionality only loads once (in case of multiple imports)
window.authInit = window.authInit || false;
if (!window.authInit) {
    window.authInit = true;

    /**
     * initiate any sub-module tbid functionality once page load has completed
     */
    document.addEventListener('readystatechange', async () => {
        if (document.readyState === 'complete') {
            // pass in user logged in state for logic in sso flow.
            initSso();
            initTracking();
        }
    });
}
